import {mltipartRequest, requestHeader, request} from './api';
import {updateQuery} from "@services/helper";

export const get = ({page=0, size=50, sort, filter}) => {
    return requestHeader(`/admin/benefits${updateQuery({page, size, filter, sort})}`, {
        method: 'GET',
    });
};

export const getAll = () => {
    return requestHeader(`/admin/benefits?page=0&size=10000`, {
        method: 'GET',
    });
};

export const create = (benefit) => {
    return request(`/admin/benefits`, {
        method: 'POST',
        body: JSON.stringify(benefit),
    });
};

export const uploadBarcodes = (id, file) => {
    return mltipartRequest(`/admin/benefits/${id}/barcodes`, {
        method: 'POST',
        body: file,
    });
};

export const uploadImg = (id, input) => {
    return mltipartRequest(`/admin/benefits/${id}/image`, {
        method: 'POST',
        body: input,
    });
};

export const uploadStatus = (id, status) => {
    return request(`/admin/benefits/${id}/status`, {
        method: 'POST',
        body: JSON.stringify({active: status}),
    });
};

export const update = (id, benefit) => {
    return request(`/admin/benefits/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(benefit),
    });
};

export const remove = (id) => {
    return request(`/admin/benefits?benefitId=${id}`, {
        method: 'DELETE',
    });
};
export const removeBarcodes = (id) => {
    return request(`/admin/barcodes?benefitId=${id}`, {
        method: 'DELETE',
    });
};

export const updateStatus = (selectedStatus, benefitId) => {
    const obj = {
        status: selectedStatus
    }
    return request(`/admin/benefits/${benefitId}/status`, {
        method: 'PATCH',
        body: JSON.stringify(obj),
    });
};

export const getById = (id) => {
    return request(`/admin/benefits/${id}`, {
        method: 'GET',
    });
};
 
export default {get}